// Tag normalisation shared by scripts/build-reco-index.js (Node) and the
// personalised rows in the browser, so both sides compare the same tag keys.
// Kept in CommonJS so the build script can require() it without ESM support.

// Tags that say nothing about what a player likes (portals, platforms, filler)
const NOISE = new Set([
  "exclusive", "girls", "girl", "girls game", "html5", "html5 game", "free", "free game",
  "free online", "free online game", "online", "browser", "browser game", "kids", "new", "hot",
  "best", "cutedressup", "playcutegames", "yandex", "crazy", "poki", "playgama", "gd", "y8",
  "yad", "yiv", "lagged", "gamezop", "gamemonetize", "dressupwho", "1 player", "funny",
  "addictive", "casual", "cute", "fun", "game", "mobile game",
]);

// Spelling variants that should count as the same interest
const ALIAS = {
  "make up": "makeup", "makeover": "makeup", "dress": "dress up", "dressup": "dress up",
  "kpop": "k pop", "blackpink": "k pop", "io": ".io", "match3": "match 3", "obby": "roblox",
  "cars": "car", "simulator": "simulation", "puzzles": "puzzle",
};

function normTag(tag) {
  const t = String(tag || "").toLowerCase().replace(/[-_]/g, " ").replace(/\s+games?$/, "").replace(/\s+/g, " ").trim();
  return ALIAS[t] || t;
}

// Unique, meaningful, normalised tags for one game
exports.normTags = function normTags(tags) {
  const out = [];
  (tags || []).forEach((tag) => {
    const t = normTag(tag);
    if (t && !NOISE.has(t) && !out.includes(t)) out.push(t);
  });
  return out;
};
